<ng-container *ngIf="params">
	<ng-container *ngTemplateOutlet="params.layout === 'inline' ? inline : normal"></ng-container>

	<ng-template #inline>
		<calao-inline-field-layout>
			<calao-inline-field-layout-content>
				<ng-container *ngTemplateOutlet="gallery"></ng-container>
			</calao-inline-field-layout-content>
		</calao-inline-field-layout>
	</ng-template>

	<ng-template #normal>
		<ng-container *ngTemplateOutlet="gallery"></ng-container>
	</ng-template>

	<ng-template #gallery>
		<calao-document-gallery [path]="params.path" [model]="model" [readonly]="params.readonly" [label]="params.label"
			(documentsChanged)="onDocumentsChanged($event)"></calao-document-gallery>
	</ng-template>
</ng-container>